import React from "react";
import Strings from "../../../config/Strings";
import {ConvertDateToReadableString} from "../../../util/ConverterUtil";
import GlobalConstants from "../../../config/GlobalConstants";
import './../Dashboard.scss';
import './DashboardCard.scss';
import {Link} from "react-router-dom";
import {TigerSpinnerWhite} from "../../../global/tiger-spinner/TigerSpinner";

export const PremiumAccessCard = (props) => {

    const {premiumAccess, loading} = props;
    if (loading) {
        return (
            <div className={"flex-spinner"}>
                <TigerSpinnerWhite/>
            </div>
        )
    }

    const isActive = premiumAccess;
    const isAppleIap = isActive && premiumAccess?.source?.type && premiumAccess.source.type.includes('APPLE');
    const isGoogleIap = isActive && premiumAccess?.source?.type && premiumAccess.source.type.includes('GOOGLE');
    const isIap = isAppleIap || isGoogleIap;
    const isTicket = isActive && premiumAccess.type && premiumAccess.type.includes('tigerticket') && !isIap;
    const hideContractLinks = false;

    const getStatusText = () => {
        return isActive ? Strings.DASHBOARD_PREMIUM_STATUS_VALUE_ACTIVE :
            Strings.DASHBOARD_PREMIUM_STATUS_VALUE_INACTIVE;
    }

    const getDurationText = () => {
        if (isTicket) {
            //Active ticket
            return Strings.DASHBOARD_PREMIUM_DURATION_VALUE_TICKET.replace("{0}", ConvertDateToReadableString(premiumAccess.validUntil, false, false));
        } else if (isActive) {
            //Active subscription
            if (isGoogleIap || isAppleIap) {
                return Strings.DASHBOARD_PREMIUM_DURATION_VALUE_SUB_IAP.replace("{0}", ConvertDateToReadableString(premiumAccess.validUntil, false, false));
            } else {
                if (premiumAccess.validUntil) {
                    return Strings.DASHBOARD_PREMIUM_DURATION_VALUE_SUB_CANCELLED.replace("{0}", ConvertDateToReadableString(premiumAccess.validUntil, false, false));
                } else {
                    return Strings.DASHBOARD_PREMIUM_DURATION_VALUE_SUB_UNCANCELLED.replace("{0}", ConvertDateToReadableString(premiumAccess.paidUntil, false, false));
                }
            }
        } else {
            return null;
        }
    }

    if (loading) {
        return <></>;
    }

    return (
        <>
            <h4 className="dashboard-card-header">{Strings.DASHBOARD_PREMIUM_CARD_LABEL}</h4>
            <div className="static-content-container">
                <div className="dashboard-card-grid">
                    <div className="py-3 w-25">
                        {isActive ? <>&#128994;</> : <>&#128308;</>}
                    </div>
                    <div className="py-1 px-2 w-50">
                        <span style={{fontWeight: "bold"}}>{getStatusText()}</span>
                        <br/>
                        <div style={{fontWeight: "bold"}} dangerouslySetInnerHTML={{__html: getDurationText()}} />
                    </div>
                    <div className="py-3 w-25">
                        {isActive ? <>&#128994;</> : <>&#128308;</>}
                    </div>
                </div>
                <hr style={{width: "270px"}}/>
                {!hideContractLinks &&
                    <div>
                        <div className="dashboard-card-grid">
                            <div className="py-3 px-2 w-100">
                                <a href={GlobalConstants.APP_PATH + "/premium/settings"}><span className="dashboard-card-link">{Strings.DASHBOARD_PREMIUM_INVOICES_OVERVIEW} &#187;</span></a>
                            </div>
                        </div>
                        <div className="dashboard-card-grid">
                            <div className="px-2 w-100">
                                <a href={GlobalConstants.APP_PATH + "/premium/settings"}><span className="dashboard-card-link">{Strings.DASHBOARD_PREMIUM_CHANGE_PAYMENT_INFO_LINK} &#187;</span></a>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div className="dashboard-card-footer centered">
                <Link to={"/" + GlobalConstants.APP_PATH + "premium"}>
                    <button
                        className={"dashboard-card-button"}
                        type="button"
                    >{Strings.DASHBOARD_PREMIUM_MAINTAIN_BUTTON}</button>
                </Link>
            </div>
        </>
    );
};